import {
  Button,
  ButtonOwnProps,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogProps,
  DialogTitle,
} from '@mui/material'
import { ReactNode } from 'react'
import useSubmitLock from 'hooks/use-submit-lock'

type ConfirmationDialogProps = {
  title: string
  children: ReactNode
  successBtnText: string
  successBtnTextStyle?: ButtonOwnProps
  handleSuccessBtn: () => void
  cancelBtnText?: string
  cancelBtnTextStyle?: ButtonOwnProps
  handleCancelBtn?: () => void
  handleClose: () => void
} & DialogProps

const disabledSx = {
  '&.Mui-disabled': {
    bgcolor: 'action.disabledBackground',
    color: 'action.disabled',
  },
}

const ConfirmationDialog = ({
  open,
  title,
  children,
  successBtnText,
  successBtnTextStyle,
  handleSuccessBtn,
  cancelBtnText,
  cancelBtnTextStyle,
  handleCancelBtn,
  handleClose,
  maxWidth = 'lg',
  fullWidth,
  ...dialogProps
}: ConfirmationDialogProps) => {
  const { isSubmitting, wrapClick } = useSubmitLock()

  return (
    <Dialog
      open={open}
      onClose={isSubmitting ? undefined : handleClose}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      {...dialogProps}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{children}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          onClick={handleCancelBtn ?? handleClose}
          disabled={isSubmitting}
          sx={{ textTransform: 'none', borderRadius: '5px', ...disabledSx }}
          {...cancelBtnTextStyle}
        >
          {cancelBtnText ?? 'Cancel'}
        </Button>
        <Button
          variant="contained"
          onClick={wrapClick(handleSuccessBtn)}
          disabled={isSubmitting}
          sx={{ textTransform: 'none', borderRadius: '5px', ...disabledSx }}
          {...successBtnTextStyle}
        >
          {successBtnText}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmationDialog
